import cx from "classnames";
import React from "react";
import Section from "../Section";

const More: React.FC = (): React.ReactElement => (
  <Section className="u-background-color-primary" id="More">
    <div
      className={cx([
        "u-flex",
        "u-flex-column",
        "u-margin-top-negative-0point875rem",
        "u-margin-bottom-negative-0point875rem",
      ])}
    >
      <div
        className={cx([
          "u-flex",
          "u-justify-content-center",
          "u-padding-bottom-0point875rem",
          "u-padding-top-0point875rem",
          "u-width-fullWidth",
        ])}
      >
        <div
          className={cx([
            "u-padding-left-0point875rem",
            "u-padding-right-0point875rem",
            "u-width-59point65-percent",
          ])}
        >
          <p
            className={cx([
              "u-color-secondary",
              "u-font-size-m",
              "u-line-height-s",
              "u-margin-bottom-0",
              "u-margin-top-0",
              "u-text-normal",
              "u-text-center",
            ])}
          >
            <b>A Little More</b>
            <br />
            <br />
            Outside of work, I&apos;m a curious explorer at heart. I love
            traveling with my partner; we usually find ourselves hopping between
            three or four different countries each year. When I&apos;m not
            planning our next trip, you&apos;ll likely find me reading—favorites
            include Circe, Project Hail Mary, and The Witcher series—or pushing
            myself in a spin class.
            <br />
            <br />
            If you want to hear any travel stories, I&apos;d love to grab coffee
            or connect via virtual chat.
            <br />
          </p>
        </div>
      </div>
    </div>
  </Section>
);

export default React.memo(More);
